const DEFAULT_TITLE = "Não foi possível importar a planilha";

function toRow(entry) {
  if (!entry) return null;

  if (typeof entry === "string") {
    return { linha: null, coluna: null, mensagem: entry };
  }

  if (!entry.mensagem) return null;

  return {
    linha: entry.linha || null,
    coluna: entry.coluna || null,
    mensagem: entry.mensagem,
  };
}

function normalizeRows(entries) {
  return entries.map(toRow).filter((row) => !!row);
}

export function normalizeImportError(error) {
  const response = error && error.response;
  const data = response && response.data;
  const errors = data && data.errors;

  if (Array.isArray(errors)) {
    const rows = normalizeRows(errors);
    if (!rows.length) return null;

    const structural = rows.every((row) => !row.linha);

    return {
      kind: structural ? "structural" : "rows",
      title: (data && data.title) || DEFAULT_TITLE,
      message: (data && data.message) || "",
      rows,
    };
  }

  if (errors && typeof errors === "object") {
    const flat = Object.keys(errors).reduce(
      (acc, key) =>
        acc.concat(Array.isArray(errors[key]) ? errors[key] : [errors[key]]),
      [],
    );
    const rows = normalizeRows(flat);
    if (!rows.length) return null;

    return {
      kind: "structural",
      title: DEFAULT_TITLE,
      message: "",
      rows,
    };
  }

  return null;
}
